import React, { useEffect, useRef, useState } from "react";
import MonitoringTab from "./MonitoringTab";
import ArchivedAlerts from "./ArchivedAlerts";
import { DialogComponent } from "../common/DialogComponent";
import AlertDetails from "../Dialogs/AlertDetails";
import CreditAlert from "./CreditAlert";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as alertActions from "../../store/AlertsService/actions";
import i18nService from "../../util/Internationalization/i18n/i18n";
import AlertDetailContainer from "./AlertDetailContainer";
import AlertL3Dialog from "../Dashboard/AlertL3Dialog";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../util/dateFormatting";
import LogoContainer from "../common/LogoContainer";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import * as ConfigurationActions from "../../store/configurationService/actions";
import TUAuthentication from "../Credit/Auth/TUAuthentication";

const ActiveAlerts = () => {
    const { t: tLang } = useTranslation();
    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState(false);
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const requestAlertData = (reload: boolean) => dispatch(alertActions.actionCreators.getAlertData(isBusinessUser, reload));
    const alerts: any = useSelector((state: ApplicationState) => (state.alertState && state.alertState.alertData ? state.alertState.alertData : []));
    const loading = useSelector((state: ApplicationState) => (state.alertState ? state.alertState.isAlertLoading : false));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    const {
        showAlertDetails,
        setShowAlertDetails,
        yScroll,
        alertDetails,
        alert,
        l3Auth,
        setL3Auth,
        creditAlertDetailsCallback,
        isIDFuser,
        csidUserStatus,
        showCreditAuth,
        creditAuthSuccessCallBack,
        closeDisclosureDialogCallBack,
    } = AlertDetailContainer();

    const handleCloseDialog = (): any => {
        setShowAlertDetails(false);
        setTimeout(()=>{
            scrollTo(0, yScroll);
        })
    };

    const authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                AUTHENTICATED: state.creditAuthData.authData["auth-status"],
            };
        }
        return { isIDFUser: "", AUTHENTICATED: "" };
    });

    useEffect(() => {
        if (refresh) {
            requestAlertData(true);
            setRefresh(false);
        }
    }, [refresh === true]);

    const history = useHistory();
    const openTrackedCase = (alertData: any) => {
        history.push("monitoring/cases", alertData);
    };

    useEffect(() => {
        const initialUrl = window.location.href;
        sessionStorage.setItem('initialUrl', encodeURIComponent(initialUrl));
        requestAlertData(false);
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const myRef = useRef<HTMLDivElement>(null);

    const executeScroll = () => {
        myRef.current && myRef.current.scrollIntoView();
    };

    const [archivedAlerts, setArchivedAlerts] = useState(true);
    const chboxToggle = (value: string) => {
        const toggle = !archivedAlerts;
        setArchivedAlerts(toggle);
        if (!archivedAlerts) executeScroll();
    };

    const needShowingCrossButton = (alrt: any): boolean => {
        return alrt["serviceType"] !== "SEXOFF-FWD";
    };

    return (
        <React.Fragment>
            <TUAuthentication />

            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="active-alerts-page">
                        {tLang("alerts.alerts.title")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>
            <MonitoringTab selectedTab="1" />
            <div className="row" style={{ minHeight: "570px" }}>
                <div className="col-xs-12 col-sm-8">
                    <div className={`box offset-padding ${loading && "loading"}`}>
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName={"bell"} />
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">{tLang("alerts.alerts.title")}</h2>
                                </div>
                            </div>
                            {alerts &&
                                Array.isArray(alerts) &&
                                alerts.filter(
                                    (alert: any) => (alert.alertStatus === "ARCHIVED" || alert.alertStatus === "Archived" || alert.alertStatus === "GOOD_ALERT_MINE")
                                    && (alert.serviceType !== 'SubscriptionEnded') ).length > 0 && (
                                    <div className="box-actions">
                                        <div className="form-input">
                                            <label className="form-checkbox-label" htmlFor="show_archived">
                                                <input
                                                    type="checkbox"
                                                    checked={archivedAlerts}
                                                    id="show_archived"
                                                    onChange={() => chboxToggle("archived-alerts")}
                                                />
                                                <span className="form-checkbox-label-text">
                                                    {tLang("alerts.alerts.checkBoxLabel")}
                                                    <span className="sr-only">{tLang("alerts.alerts.title")}</span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                )}
                        </div>
                        <div className="box-content">
                            {alerts && Array.isArray(alerts) && alerts.length > 0 ? (
                                <div role="alert" id="active-alerts" aria-labelledby="active-alerts-title">
                                    <h3 className="content-sub-title" id="active-alerts-title">
                                        {tLang("alerts.alerts.activeAlertListTitle")} (
                                        <span id="active-alert-count">
                                            {alerts && Array.isArray(alerts)
                                                ? alerts.filter(
                                                      (alert: any) =>
                                                          alert.alertStatus === "NEW" ||
                                                          alert.alertStatus === "New" ||
                                                          alert.alertStatus === "Viewed" ||
                                                          alert.alertStatus === "GOOD_ALERT" ||
                                                          alert.alertStatus === "VIEWED"
                                                  ).length
                                                : 0}
                                        </span>
                                        )
                                    </h3>

                                    <ul id="active-alerts-list">
                                        {alerts &&
                                            Array.isArray(alerts) &&
                                            alerts
                                                .filter(
                                                    (alert: any) =>
                                                        (alert.alertStatus === "New" ||
                                                        alert.alertStatus === "Viewed" ||
                                                        alert.alertStatus === "NEW" ||
                                                        alert.alertStatus === "GOOD_ALERT" ||
                                                        alert.alertStatus === "VIEWED") &&
                                                        (alert.serviceType !== "SubscriptionEnded")
                                                       
                                                )
                                                .map((alert: any, index: number) => {
                                                    return (
                                                        <li key={alert.alertID} onClick={() => alertDetails(alert)}>
                                                            <div className="monitoring-alert-container status-alert">
                                                                <a href="#" onClick={(e) => e.preventDefault()}>
                                                                    <span className="row">
                                                                        <span className="col-xs col-no-gutter">
                                                                            <span className="monitoring-alert-date">
                                                                                <span className="sr-only">Alert Date:</span>
                                                                                {alert.createdDate &&
                                                                                    getFormattedDate(i18nService.get("Country"), alert.createdDate)}
                                                                            </span>
                                                                            <span className="monitoring-alert-description">
                                                                                <span className="sr-only">Critical Alert</span>{" "}
                                                                                {(isBusinessUser ? "Business " : "") + alert.displayName}
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                    </ul>
                                </div>
                            ) : (
                                <div className="row" style={{ minHeight: "170px" }}>
                                    <div className="box" style={{ backgroundColor: "#F2F6F9" }}>
                                        <div className="box-header col-xs-12 col-sm-12">
                                            <div className="content-sub-title text-align-center">
                                                <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                                                    <em className="las la-exclamation-circle "></em>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="box-content text-align-center">
                                            <p>{tLang("alerts.alerts.noAlertMessage")}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div role="alert" ref={myRef} id="archived-alerts" aria-label="archived alerts title">
                                {alerts &&
                                    Array.isArray(alerts) &&
                                    alerts.filter(
                                        (alert: any) =>
                                            alert.alertStatus === "GOOD_ALERT_MINE" || alert.alertStatus === "ARCHIVED" || alert.alertStatus === "Archived"
                                    ).length > 0 &&
                                    archivedAlerts && (
                                        <ArchivedAlerts
                                            refresh={setRefresh}
                                            archivedAlerts={alerts.filter(
                                                (alert: any) =>
                                                    alert.alertStatus === "GOOD_ALERT_MINE" || alert.alertStatus === "ARCHIVED" || alert.alertStatus === "Archived"
                                            )}
                                        />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                {!authData.isIDFUser && (
                    <div className="col-xs-12 col-sm-4">
                        <div className="box box-border-top">
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-icon position-right" aria-hidden="true">
                                        <RenderIcons iconName="briefcase" />
                                    </div>
                                    <div className="box-title-text">
                                        <h3 className="box-title">{tLang("alerts.alerts.caseTrackerWidget.title")}</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="box-content">
                                <p>
                                    <strong>
                                        {tLang("alerts.alerts.caseTrackerWidget.caseListtitle")} (
                                        <span id="open-cases-count">
                                            {alerts && Array.isArray(alerts)
                                                ? alerts.filter((alert: any) => alert.alertStatus === "OPENCASE" || alert.alertStatus === "OPENED").length
                                                : 0}
                                        </span>
                                        )
                                    </strong>
                                </p>

                                <ul id="case-list">
                                    {alerts &&
                                        Array.isArray(alerts) &&
                                        alerts
                                            .filter((alert: any) => alert.alertStatus === "OPENCASE" || alert.alertStatus === "OPENED")
                                            .map((alert: any, index: number) => {
                                                return (
                                                    <li key={alert.alertID}>
                                                        <a
                                                            href="javascript:void(0)"
                                                            className="case-link"
                                                            onClick={() => {
                                                                openTrackedCase(alert);
                                                            }}
                                                        >
                                                            <span className="case-icon">
                                                                <em className="las la-clipboard"></em>
                                                            </span>
                                                            <span className="case-description">
                                                                <span className="sr-only">View Case</span>
                                                                {(isBusinessUser ? "Business " : "") + alert.displayName}
                                                            </span>
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {showAlertDetails && (
                <DialogComponent
                    hideCloseButton={needShowingCrossButton(alert)}
                    dialogId="alert-details-dialog"
                    title="Alert Details"
                    closeDialog={handleCloseDialog}
                >
                    <AlertDetails refresh={setRefresh} alert={alert} />
                </DialogComponent>
            )}
            {l3Auth && <CreditAlert triggeredFrom="Alerts" setL3Auth={setL3Auth} alertDetails={alert} creditAlertDetailsCallback={creditAlertDetailsCallback} />}

            <AlertL3Dialog
                showCreditAuth={showCreditAuth}
                csidUserStatus={csidUserStatus}
                closeDisclosureDialogCallBack={closeDisclosureDialogCallBack}
                creditAuthSuccessCallBack={creditAuthSuccessCallBack}
                isIDFuser={isIDFuser}
            />
        </React.Fragment>
    );
};

export default ActiveAlerts;
